/**
 * Labstep
 *
 * @module components/Folder/Form/Create
 * @desc Folder Form Create
 */

import { fieldName } from 'labstep-web/components/Folder/Form/fields';
import { FormCreateContainer as FormCreate } from 'labstep-web/core/Form/Create';
import { Folder } from 'labstep-web/models/folder.model';
import type React from 'react';
import type { FolderFormCreateProps } from './types';

export const FolderFormCreate: React.FC<FolderFormCreateProps> = ({
  type,
  ...rest
}) => (
  <FormCreate
    autoFocus
    entityName={Folder.entityName}
    body={{ type }}
    fields={[fieldName]}
    {...rest}
  />
);
